import axios from "axios";
import { getApiBaseUrl } from "./baseUrl";

const api = axios.create({ baseURL: getApiBaseUrl() });

// 요청마다 토큰 자동 주입
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401 응답 시 전역 로그아웃 이벤트 발행
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      window.dispatchEvent(new Event("auth:logout"));
    }
    return Promise.reject(err);
  }
);

// ── 프로젝트 API ────────────────────────────────────────────
export const projectApi = {
  /** 목록 조회 (search, category='dev'|'security', tag, page, limit) */
  getList: ({ search = "", category = "", tag = "", page = 1, limit = 12 } = {}) =>
    api.get("/projects", { params: { search, category, tag, page, limit } }),

  /** 단건 조회 */
  getOne: (id) => api.get(`/projects/${id}`),

  /** 수정용 조회 (조회수 증가 없음, 관리자) */
  getForEdit: (id) => api.get(`/projects/edit/${id}`),

  /** 기술 태그 목록 + 카운트 */
  getTags: () => api.get("/projects/tags"),

  /** 글 작성 (관리자) */
  create: (data) => api.post("/projects", data),

  /** 글 수정 (관리자) */
  update: (id, data) => api.put(`/projects/${id}`, data),

  /** 글 삭제 (관리자) */
  remove: (id) => api.delete(`/projects/${id}`),

  /** 조회수 증가 */
  increaseView: (id) => api.post(`/projects/${id}/view`),

  /** 이미지 업로드 */
  uploadImage: (file, onProgress) => {
    const form = new FormData();
    form.append("image", file);
    return api.post("/projects/upload", form, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded * 100) / e.total));
        }
      },
    });
  },

  /** 이미지 삭제 */
  deleteImage: (key) => api.delete(`/projects/upload/${key}`),
};
